<template>
    <div>
        <div class="main-container">
            <resourceDataTable :resultId="resultId"></resourceDataTable>
            <div style="width: 100px;height: 50px;margin-top: -10px;margin-left: -72px;">
                <el-button type="primary" @click="back">返回列表</el-button>
            </div>
        </div>
    </div>
</template>
  
<script>
import resourceDataTable from './resourceTable.vue';
export default {
    components: { resourceDataTable },
    data() {
        return {
            resultId: 0
        }
    },
    methods: {
        back() {
            this.$router.push({ path: '/unicomData/fenceUpload' })
        }
    },
    created() {
        if (this.$route.query.data) {
            this.resultId = this.$route.query.data
        }
    }
}
</script>
  
<style scoped>
.main-container {
    display: flex;
    width: 800px;
    padding: 30px;
    margin: 0 auto;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/unicomData/viewTable.vue